var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-search-toggle",on:{"click":_vm.toggleSearch}},[_c('span',{staticClass:"header-search-toggle__text"},[_vm._v("Поиск")]),_c('inline-svg',{attrs:{"src":"search"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }